/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-unused-vars */
import React from 'react';
import { Controller } from 'react-hook-form';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO, isValid } from 'date-fns';

export const FormDateSelector = ({
  label,
  name,
  control,
  rules = {},
  defaultValue,
  size = 'small',
  inputFormat = 'MM/dd/yyyy',
  onSelect = () => undefined,
  disabled = false,
  maxDate,
  minDate,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue ?? null}
      render={({
        field: { onChange, onBlur, ref, value, ...inputProps },
        fieldState: { error },
      }) => {
        const dateValue =
          // eslint-disable-next-line no-nested-ternary
          value && typeof value === 'string' && value.trim() !== ''
            ? parseISO(value)
            : value instanceof Date && isValid(value)
            ? value
            : null;

        return (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label={label}
              value={dateValue}
              onChange={e => {
                onSelect(e);
                onChange(e);
              }}
              onBlur={onBlur}
              inputRef={ref}
              inputFormat={inputFormat}
              slotProps={{ textField: { size }, flex: 1 }}
              error={error}
              {...inputProps}
              disableOpenPicker={disabled}
              disabled={disabled}
              maxDate={maxDate}
              minDate={minDate}
            />
          </LocalizationProvider>
        );
      }}
    />
  );
};
